import { apiSlice } from "./apiSlice";

export const lazyGradesApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getLazyGradesBySubject: builder.query({
			query: ({ subjectId, departmentId }) =>
				`/LazyGrades/subject/${subjectId}/department/${departmentId}`,
			providesTags: (result, error, { subjectId, departmentId }) => [
				{ type: "LazyGrades", id: `subject-${subjectId}-${departmentId}` },
			],
		}),

		getLazyGradesByStudent: builder.query({
			query: (studentId) => `/LazyGrades/student/${studentId}`,
			providesTags: (result, error, studentId) => [
				{ type: "LazyGrades", id: `student-${studentId}` },
			],
		}),
	}),
});

export const {
	useLazyGetLazyGradesBySubjectQuery,
	useLazyGetLazyGradesByStudentQuery,
} = lazyGradesApiSlice;
